/*
 * Public API Surface of ngx-chart
 */


export * from './lib/ngx-chart.module';
export * from './lib/_component/bar-chart/bar-chart.component';
export * from './lib/_component/donut-chart/donut-chart.component';
export * from './lib/_component/pie-chart/pie-chart.component';
export * from './lib/_model/index'
